import React from "react";
import UserManagementTable from "./UserManagementTable";


const UserManagementPage = () => {
  return (
      <UserManagementTable />
  );
};

export default UserManagementPage;